<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
		>
			<el-table-column prop="id" label="ID" width="80px"></el-table-column>

			<el-table-column prop="title" label="市场标题" min-width="200px" show-overflow-tooltip>
			</el-table-column>

			<el-table-column label="交易量" width="120px">
				<template slot-scope="scope">
					<span>{{ formatNumber(scope.row.volume) }}</span>
				</template>
			</el-table-column>

			<el-table-column label="流动性" width="120px">
				<template slot-scope="scope">
					<span>{{ formatNumber(scope.row.liquidity) }}</span>
				</template>
			</el-table-column>

			<el-table-column label="当前价格" width="120px">
				<template slot-scope="scope">
					<span>{{ formatNumber(scope.row.current_price) }}</span>
				</template>
			</el-table-column>

			<el-table-column label="状态" width="100px">
				<template slot-scope="scope">
					<el-tag
						:type="getStatusType(scope.row.status)"
						size="small"
					>
						{{ getStatusText(scope.row.status) }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="create_time" label="创建时间" width="160px">
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="150px">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						@click="handleDetail(scope.row)"
					>
						详情
					</el-button>
					<el-button
						type="text"
						size="small"
						@click="viewSnapshots(scope.row)"
					>
						价格历史
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 详情对话框 -->
		<el-dialog
			title="市场详情"
			:visible.sync="detailDialogVisible"
			width="800px"
			:append-to-body="true"
		>
			<div v-if="currentMarket" class="detail-content">
				<el-descriptions :column="2" border>
					<el-descriptions-item label="ID">
						{{ currentMarket.id }}
					</el-descriptions-item>
					<el-descriptions-item label="事件ID">
						{{ currentMarket.event_id }}
					</el-descriptions-item>
					<el-descriptions-item label="标题" :span="2">
						{{ currentMarket.title }}
					</el-descriptions-item>
					<el-descriptions-item label="交易量">
						{{ formatNumber(currentMarket.volume) }}
					</el-descriptions-item>
					<el-descriptions-item label="流动性">
						{{ formatNumber(currentMarket.liquidity) }}
					</el-descriptions-item>
					<el-descriptions-item label="当前价格">
						{{ formatNumber(currentMarket.current_price) }}
					</el-descriptions-item>
					<el-descriptions-item label="状态">
						<el-tag
							:type="getStatusType(currentMarket.status)"
							size="small"
						>
							{{ getStatusText(currentMarket.status) }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="创建时间">
						{{ currentMarket.create_time }}
					</el-descriptions-item>
					<el-descriptions-item label="更新时间">
						{{ currentMarket.update_time }}
					</el-descriptions-item>
					<el-descriptions-item label="描述" :span="2">
						<div class="description-text">
							{{ currentMarket.description || "-" }}
						</div>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "PredictionMarketTable",
	props: {
		tableData: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			detailDialogVisible: false,
			currentMarket: null,
		};
	},
	methods: {
		// 格式化数字
		formatNumber(num) {
			if (!num) return "0";
			return parseFloat(num).toLocaleString();
		},

		// 获取状态颜色
		getStatusType(status) {
			const map = {
				active: "success",
				closed: "info",
				ended: "warning",
			};
			return map[status] || "info";
		},

		// 获取状态文本
		getStatusText(status) {
			const map = {
				active: "活跃",
				closed: "关闭",
				ended: "结束",
			};
			return map[status] || status;
		},

		// 查看详情
		handleDetail(row) {
			this.currentMarket = row;
			this.detailDialogVisible = true;
		},

		// 查看价格历史
		viewSnapshots(row) {
			// TODO: 跳转到价格历史页面
			this.$message.info("价格历史功能开发中...");
		},
	},
};
</script>

<style scoped>
.detail-content {
	max-height: 600px;
	overflow-y: auto;
}
.description-text {
	max-height: 200px;
	overflow-y: auto;
	line-height: 1.6;
	white-space: pre-wrap;
	word-break: break-word;
}
</style>